import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { AppConfigService } from 'app/shared/service/app-config.service';
import { Observable } from 'rxjs';
import { MessageService } from 'primeng/api';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Component({
    selector: 'app-monitoring',
    templateUrl: './monitoring.component.html',
    styleUrls: ['./monitoring.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class MonitoringComponent implements OnInit {
    totalDiskSpace: string = '';
    freeDiskSpace: string = '';
    memory: any[] = [];
    actuators: any[] = [];
    metrics: string[] = [];
    urlLogFile: string;
    colorChart = { domain: ['#4867d2', '#5c84f1', '#89a9f4'] };

    constructor(
        private _httpClient: HttpClient,
        private _configService: AppConfigService,
        private _messageService: MessageService
    ) { }

    ngOnInit(): void {
        this.loadActuator('/health').subscribe(data => {
            this.totalDiskSpace = this.formatByte(data.details.diskSpace.details.total);
            this.freeDiskSpace = this.formatByte(data.details.diskSpace.details.free);
        });
        this.loadActuator('/metrics/jvm.memory.max').subscribe(data => {
            let maxMemory = {
                "name": 'Max Memory',
                "value": data.measurements[0].value,
                "unite": this.formatByte(data.measurements[0].value)
            };
            this.memory.push(maxMemory);
        });
        this.loadActuator('/metrics/jvm.memory.used').subscribe(data => {
            let usedMemory = {
                "name": 'Used Memory',
                "value": data.measurements[0].value,
                "unite": this.formatByte(data.measurements[0].value)
            };
            this.memory.push(usedMemory);
        });
        this.loadActuator('').subscribe(data => {
            this.actuators = Object.keys(data._links).filter(key => !data._links[key].templated)
                .map(key => ({ name: key, href: this._configService.config.apiUrl.includes('https://') ? data._links[key].href.replace('http', 'https') : data._links[key].href }));
            this.urlLogFile = this.actuators.find(a => a.name == 'logfile').href;
        });
        this.loadActuator('/metrics').subscribe(data => {
            this.metrics = data.names;
            this.metrics = this.metrics.sort();
        });
    }

    downloadLogs() {
        this.downloadZip('/monitoring/logs');
    }

    downloadDump() {
        this.downloadZip('/monitoring/dump-db');
    }

    private downloadZip(url: string) {
        this._httpClient.get(this._configService.config.apiUrl + url, { responseType: 'blob', observe: 'response' }
        ).subscribe(
            response => {
                let fileName: string;
                let contentDisposition = response.headers.get('Content-Disposition');
                if (contentDisposition && contentDisposition.split(';')[1]) {
                    fileName = contentDisposition.split('"').join('').split(';')[1].split('=')[1];
                }
                if (!fileName) {
                    fileName = url.substring(url.lastIndexOf('/') + 1) + '.zip';
                }
                let blob = new Blob([response.body], { type: 'application/zip' });
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
            }
        );
    }

    loadActuator(url: string): Observable<any> {
        return this._httpClient.get<any>(this._configService.config.apiUrl + '/actuator' + url);
    }

    private formatByte(byte: number): string {
        let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (byte == 0) return '0 Byte';
        let i = Math.floor(Math.log(byte) / Math.log(1024));
        return Math.round(byte / Math.pow(1024, i)) + sizes[i];
    }

    loadActuatorNewWindow(url: string, responseType: any = 'json') {
        this._httpClient.get(url, { observe: 'response', responseType: responseType }
        ).subscribe(
            response => {
                var text;
                if (responseType == 'json')
                    text = JSON.stringify(response.body, null, 2);
                else
                    text = response.body;
                var x = window.open();
                x.document.open();
                x.document.write('<html><body><pre>' + text + '</pre></body></html>');
                x.document.close();
            }
        );
    }

    purgeActionLogs(): void {
        this._httpClient.get(this._configService.config.apiUrl + '/actionlogs/backup', { responseType: 'text', observe: 'response' })
            .pipe(
                tap(response => {
                    if (response.status === 200) {
                        this._messageService.add({
                            severity: 'success',
                            summary: 'Success',
                            detail: 'Action logs purged successfully'
                        });
                    }
                }),
                catchError(error => {
                    console.error('Purge action logs error:', error);
                    this._messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to purge action logs'
                    });
                    return throwError(() => error);
                })
            )
            .subscribe();
    }

    syncPrivilege(): void {
        this._httpClient.get(this._configService.config.apiUrl + '/objet-privileges/update_priviliges', { responseType: 'text', observe: 'response' })
            .pipe(
                tap(response => {
                    if (response.status === 200) {
                        this._messageService.add({
                            severity: 'success',
                            summary: 'Success',
                            detail: 'Privileges synchronized successfully'
                        });
                    }
                }),
                catchError(error => {
                    console.error('Sync privileges error:', error);
                    this._messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to synchronize privileges'
                    });
                    return throwError(() => error);
                })
            )
            .subscribe();
    }
}